import React from 'react';
import { Scissors, Shovel, Hammer, Droplets, Leaf, Sprout } from 'lucide-react';
const services = [{
  icon: <Scissors className="w-8 h-8 text-brand" data-id="element-111" />,
  title: 'Lawn Care and Maintenance',
  description: 'Weekly and bi-weekly mowing, edging, blowing, and seasonal cleanups to keep your yard looking sharp year-round.'
}, {
  icon: <Sprout className="w-8 h-8 text-brand" data-id="element-112" />,
  title: 'Landscape Design and Install',
  description: 'Custom planting plans, flower beds, sod installation, trees, and mulching to transform your outdoor space.'
}, {
  icon: <Hammer className="w-8 h-8 text-brand" data-id="element-113" />,
  title: 'Hardscaping',
  description: 'Patios, walkways, retaining walls, pavers, and stone features built to last and look great.'
}, {
  icon: <Shovel className="w-8 h-8 text-brand" data-id="element-114" />,
  title: 'Drainage Solutions',
  description: 'French drains, grading, and erosion control so your yard stays dry and healthy after Texas rain.'
}, {
  icon: <Leaf className="w-8 h-8 text-brand" data-id="element-115" />,
  title: 'Seasonal Cleanups',
  description: 'Spring and fall cleanups, leaf removal, and bed prep to keep things tidy every season.'
}, {
  icon: <Droplets className="w-8 h-8 text-brand" data-id="element-116" />,
  title: 'Irrigation',
  description: 'Sprinkler system installs, repairs, and seasonal adjustments to keep your lawn watered efficiently.'
}];
export function Services() {
  return <section id="services" className="py-20 md:py-28 bg-white" data-id="element-117">
      <div className="container mx-auto px-6 max-w-7xl" data-id="element-118">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-119">
          <h2 className="font-heading font-bold text-3xl md:text-4xl text-gray-900 mb-4 inline-block relative" data-id="element-120">
            What We Do
            <span className="absolute -bottom-2 left-1/4 right-1/4 h-1 bg-brand rounded-full" data-id="element-121"></span>
          </h2>
          <p className="text-lg text-gray-600 mt-6" data-id="element-122">
            Landscaping, hardscaping, and everything in between.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-123">
          {services.map((service, index) => <div key={index} className="bg-white rounded-2xl p-8 shadow-sm border border-gray-100 border-t-4 border-t-brand hover:shadow-xl transition-shadow duration-300 flex flex-col h-full" data-id="element-124">
              <div className="bg-brand/10 w-16 h-16 rounded-xl flex items-center justify-center mb-6" data-id="element-125">
                {service.icon}
              </div>
              <h3 className="font-heading font-bold text-xl text-gray-900 mb-3" data-id="element-126">
                {service.title}
              </h3>
              <p className="text-gray-600 flex-grow mb-6" data-id="element-127">
                {service.description}
              </p>
              <a href="#contact" className="text-brand font-bold hover:text-brand-light transition-colors inline-flex items-center mt-auto min-h-[44px]" data-id="element-128">
                Learn More <span className="ml-2" data-id="element-129">→</span>
              </a>
            </div>)}
        </div>
      </div>
    </section>;
}